export function DeriveNew<T extends object>(base: T, newEntityScheme: TInheritFrom<T>): T {
	// If inheritance is not stipulated in the new entity scheme
	if (!newEntityScheme._inherit) {
		return newEntityScheme;
	}

	if (![Object.prototype, Array.prototype].includes(Object.getPrototypeOf(base))) {
		throw new Error('Inheritance can only be applied to entities that are DIRECT prototypes of Array/Object');
	}

	const newEntity: TInheritFrom<T> = Object.assign(base instanceof Array ? [] : {}, base);

	for (const key in newEntityScheme) {
		(newEntity[key] as unknown) = base[key] instanceof Object ? DeriveNew(base[key], newEntityScheme[key]) : newEntityScheme[key];
	}

	// Remove the inherit marker
	delete newEntity._inherit;

	return newEntity;
}

type TInheritFrom<T extends object> =
	// If inheritance is not specified, the type resolves to the source type T.
	| (T & { _inherit?: false })

	// Otherwise, all properties will be inherited. Properties can be explicitly specified to 'override' those present on the source.
	| ({ _inherit: true } & {
			[P in keyof T]?: T[P] extends object
				? TInheritFrom<T[P] extends Array<unknown> ? Partial<{ [idx: number]: T[P][number] }> : T[P]>
				: T[P];
	  });
